import { Routes } from '@angular/router';
import { RequestMapper } from './request-mapper';
import { LoginPageComponent } from './components/login-page/login-page.component';
import { SideNavComponent } from './components/side-nav/side-nav.component';
import { FilterAndSearchComponent } from './components/filter-and-search/filter-and-search.component';
import { HomeSearchComponent } from './components/home-search/home-search.component';
import { CompareDevoteeComponent } from './components/compare-devotee/compare-devotee.component';
import { ChangePrimaryDevoteeComponent } from './components/change-primary-devotee/change-primary-devotee.component';
import { ChangeFcComponent } from './components/change-fc/change-fc.component';
import { LoaderScreenComponent } from './components/loader-screen/loader-screen.component';
import { ManualUpdateComponent } from './components/manual-update/manual-update.component';
import { OccupancyStatisticsComponent } from './components/occupancy-statistics/occupancy-statistics.component';
import { EstablishmentBookingsComponent } from './components/establishment-bookings/establishment-bookings.component';
import { EstablishmentCheckinCheckoutComponent } from './components/establishment-checkin-checkout/establishment-checkin-checkout.component';
import { EstablishmentPropertiesComponent } from './components/establishment-properties/establishment-properties.component';
import { EstablishmentUtsavsComponent } from './components/establishment-utsavs/establishment-utsavs.component';
import { EstablishmentReportsComponent } from './components/establishment-reports/establishment-reports.component';
import { EstablishmentBranchConfigComponent } from './components/establishment-branch-config/establishment-branch-config.component';
import { MediaLibraryComponent } from './components/media-library/media-library.component';
import { PlatformReportsComponent } from './components/platform-reports/platform-reports.component';
import { EstablishmentStaffComponent } from './components/establishment-staff/establishment-staff.component';
import { FrontdeskDashboardComponent } from './components/frontdesk-dashboard/frontdesk-dashboard.component';
import { FrontdeskCheckinDeskComponent } from './components/frontdesk-checkin-desk/frontdesk-checkin-desk.component';
import { FrontdeskCheckoutDeskComponent } from './components/frontdesk-checkout-desk/frontdesk-checkout-desk.component';
import { FrontdeskGuestHistoryComponent } from './components/frontdesk-guest-history/frontdesk-guest-history.component';
import { FrontdeskMyActivityComponent } from './components/frontdesk-my-activity/frontdesk-my-activity.component';
import { FrontdeskMyProfileComponent } from './components/frontdesk-my-profile/frontdesk-my-profile.component';
import { FrontdeskBookingSearchComponent } from './components/frontdesk-booking-search/frontdesk-booking-search.component';
import { ProvisionDashboardComponent } from './components/provision-dashboard/provision-dashboard.component';
import { ProvisionRequisitionSearchComponent } from './components/provision-requisition-search/provision-requisition-search.component';
import { ProvisionQueueComponent } from './components/provision-queue/provision-queue.component';
import { ProvisionManualComponent } from './components/provision-manual/provision-manual.component';
import { ProvisionDevoteeUtilsComponent } from './components/provision-devotee-utils/provision-devotee-utils.component';
import { OaBlockDayComponent } from './components/oa-block-day/oa-block-day.component';
import { OaOperatorsComponent } from './components/oa-operators/oa-operators.component';
import { SaUsersComponent } from './components/sa-users/sa-users.component';
import { SaRolesComponent } from './components/sa-roles/sa-roles.component';
import { SaEstablishmentsComponent } from './components/sa-establishments/sa-establishments.component';
import { SaViewsComponent } from './components/sa-views/sa-views.component';
import { SaViewAsRoleComponent } from './components/sa-view-as-role/sa-view-as-role.component';
import { OaUtsavComponent } from './components/oa-utsav/oa-utsav.component';
import { OaRoomCatalogueComponent } from './components/oa-room-catalogue/oa-room-catalogue.component';
import { OaAdminReqComponent } from './components/oa-admin-req/oa-admin-req.component';
import { ContextSelectComponent } from './components/context-select/context-select.component';
import { permissionGuard } from './guards/permission.guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: RequestMapper.LOGIN,
    pathMatch: 'full',
  },

  // {
  //     path: RequestMapper.LOGIN, component: LoginPageComponent
  // },
  {
    path: RequestMapper.LOGIN,
    component: LoaderScreenComponent,
    // canActivate: [LoginGuard],
    // children: [
    //   {
    //     path: 'register',
    //     loadComponent: () =>
    //       import(
    //         './views/register-acco/register-acco.component'
    //       ).then((c) => c.RegisterAccoComponent)
    //   }
    // ]
  },

  {
    path: RequestMapper.SELECT_CONTEXT,
    component: ContextSelectComponent,
  },

  {
    path: RequestMapper.SIDENAV,
    component: SideNavComponent,
    children: [
      {
        path: RequestMapper.FILTERANDSEARCH,
        component: FilterAndSearchComponent,
        canActivate: [permissionGuard],
      },
      {
        path: RequestMapper.PROFILE_SEARCH,
        component: HomeSearchComponent,
        canActivate: [permissionGuard],
      },
      {
        path: RequestMapper.DEVOTEE_COMPARE,
        component: CompareDevoteeComponent,
        canActivate: [permissionGuard],
      },
      {
        path: RequestMapper.CHANGE_PRIMARY_DEVOTEE,
        component: ChangePrimaryDevoteeComponent,
        canActivate: [permissionGuard],
      },
      {
        path: RequestMapper.CHANGE_FC,
        component: ChangeFcComponent,
        canActivate: [permissionGuard],
      },
      {
        path: RequestMapper.MANUAL_UPDATE,
        component: ManualUpdateComponent,
        canActivate: [permissionGuard],
      },
      {
        path: RequestMapper.OCCUPANCY_STATISTICS,
        component: OccupancyStatisticsComponent,
        canActivate: [permissionGuard],
      },
      {
        path: RequestMapper.ESTAB_BOOKINGS,
        component: EstablishmentBookingsComponent,
        canActivate: [permissionGuard],
      },
      {
        path: RequestMapper.ESTAB_CHECKIN_CHECKOUT,
        component: EstablishmentCheckinCheckoutComponent,
        canActivate: [permissionGuard],
      },
      {
        path: RequestMapper.ESTAB_PROPERTIES,
        component: EstablishmentPropertiesComponent,
        canActivate: [permissionGuard],
      },
      {
        path: RequestMapper.ESTAB_UTSAV_SETUP,
        component: EstablishmentUtsavsComponent,
        canActivate: [permissionGuard],
      },
      {
        path: RequestMapper.ESTAB_REPORTS,
        component: EstablishmentReportsComponent,
        canActivate: [permissionGuard],
      },
      {
        path: RequestMapper.ESTAB_BRANCH_CONFIG,
        component: EstablishmentBranchConfigComponent,
        canActivate: [permissionGuard],
      },
      {
        path: RequestMapper.ESTAB_STAFF,
        component: EstablishmentStaffComponent,
        canActivate: [permissionGuard],
      },
      {
        path: RequestMapper.MEDIA,
        component: MediaLibraryComponent,
        canActivate: [permissionGuard],
      },
      {
        path: RequestMapper.PLATFORM_REPORTS,
        component: PlatformReportsComponent,
        canActivate: [permissionGuard],
      },
      {
        path: RequestMapper.FD_DASHBOARD,
        component: FrontdeskDashboardComponent,
        canActivate: [permissionGuard],
      },
      {
        path: RequestMapper.FD_CHECKIN_DESK,
        component: FrontdeskCheckinDeskComponent,
        canActivate: [permissionGuard],
      },
      {
        path: RequestMapper.FD_CHECKOUT_DESK,
        component: FrontdeskCheckoutDeskComponent,
        canActivate: [permissionGuard],
      },
      {
        path: RequestMapper.FD_GUEST_HISTORY,
        component: FrontdeskGuestHistoryComponent,
        canActivate: [permissionGuard],
      },
      {
        path: RequestMapper.FD_MY_ACTIVITY,
        component: FrontdeskMyActivityComponent,
        canActivate: [permissionGuard],
      },
      {
        path: RequestMapper.FD_MY_PROFILE,
        component: FrontdeskMyProfileComponent,
        canActivate: [permissionGuard],
      },
      {
        path: RequestMapper.FD_BOOKING_SEARCH,
        component: FrontdeskBookingSearchComponent,
        canActivate: [permissionGuard],
      },
      {
        path: RequestMapper.PROV_DASHBOARD,
        component: ProvisionDashboardComponent,
        canActivate: [permissionGuard],
      },
      {
        path: RequestMapper.PROV_REQ_SEARCH,
        component: ProvisionRequisitionSearchComponent,
        canActivate: [permissionGuard],
      },
      {
        path: RequestMapper.PROV_QUEUE,
        component: ProvisionQueueComponent,
        canActivate: [permissionGuard],
      },
      {
        path: RequestMapper.PROV_MANUAL,
        component: ProvisionManualComponent,
        canActivate: [permissionGuard],
      },
      {
        path: RequestMapper.PROV_DEVOTEE_UTILS,
        component: ProvisionDevoteeUtilsComponent,
        canActivate: [permissionGuard],
      },
      {
        path: RequestMapper.OA_BLOCK,
        component: OaBlockDayComponent,
        canActivate: [permissionGuard],
      },
      {
        path: RequestMapper.OA_OPERATORS,
        component: OaOperatorsComponent,
        canActivate: [permissionGuard],
      },
      {
        path: RequestMapper.OA_UTSAV,
        component: OaUtsavComponent,
        canActivate: [permissionGuard],
      },
      {
        path: RequestMapper.OA_ROOM_CATALOGUE,
        component: OaRoomCatalogueComponent,
        canActivate: [permissionGuard],
      },
      {
        path: RequestMapper.OA_ADMIN_REQ,
        component: OaAdminReqComponent,
        canActivate: [permissionGuard],
      },
      {
        path: RequestMapper.SA_USERS,
        component: SaUsersComponent,
        canActivate: [permissionGuard],
      },
      {
        path: RequestMapper.SA_ROLES,
        component: SaRolesComponent,
        canActivate: [permissionGuard],
      },
      {
        path: RequestMapper.SA_ESTABLISHMENTS,
        component: SaEstablishmentsComponent,
        canActivate: [permissionGuard],
      },
      {
        path: RequestMapper.SA_VIEWS,
        component: SaViewsComponent,
        canActivate: [permissionGuard],
      },
      {
        path: RequestMapper.SA_VIEW_AS_ROLE,
        component: SaViewAsRoleComponent,
        canActivate: [permissionGuard],
      },
    ],
  },
];
